import { makeStyles } from '@material-ui/core/styles';

const fontGeneral = (fontSize, fontWeight, lineHeight, color) => {
    var result = {
        fontFamily: ['"Brown"'].join(','),
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        fontSize: fontSize,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        color: color,
    }
    return result;
};


const FormStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        // top: '-20px',
        zIndex: '0',
    },

    section: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        // zIndex: '0',
    },



    sectionHomeVideo: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '0',
    },

    sectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
    },

    sectionBoxColumn: {
        width: '81%',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            // width: '100%',
        },
    },

    videoBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '576px',
        zIndex: '-1',

        '& video': {
            position: 'absolute',
            objectFit: 'cover',
            width: '100%',
            height: '100%',
        },
        '& svg': {
            fill: '#ffffff',
            width: '40px',
            height: '40px',
            padding: '10px 12px',
            position: 'absolute',
            bottom: '0',
            right: '0',
            cursor: 'pointer',
        },

        '& #playButton': {
            top: '0',
            right: '0',
            left: '0',
            bottom: '0',
            width: '80px',
            height: '80px',
            opacity: '0.2',
            padding: '0px',
            margin: 'auto',
        },
        '& #playButton:hover': {
            opacity: '1',
            zIndex: '99',
            fill: '#ffffff',
        },

        '& span': {
            textAlign: 'center',
            top: '50%',
            right: '0',
            left: '0',
            // bottom: '0',
            position: 'absolute',
            cursor: 'pointer',
            padding: '0px',
            margin: 'auto',
            opacity: '0.4',
            ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
        },

        '& span:hover': {
            opacity: '1',
            zIndex: '99',
            fill: '#ffffff',
        },


        [theme.breakpoints.down('xs')]: {
            height: '660px',
        },

    },

    videoBackground_section: {
        position: 'absolute',
        // objectFit: 'cover',
        width: '100%',
        height: '100%',
    },

    videoLayer: {
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.7)',
        zIndex: '0',
        // cursor: 'pointer',
    },

    homeDialogVideo: {
        padding: '10px 10px !important',
        '& .MuiDialogContent-root:first-child': {
            padding: '0px !important 10px'
        },
        '& video': {
            width: '100%',
        },
        '& #closeButton': {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    },

    firstSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '0 16px',
        display: 'flex',
        color: '#000000',
        flexDirection: 'column',
        alignItems: 'center',

        '& h1': {
            width: '83.33%',
            marginTop: '206px',
            marginBottom: '24px',
            textAlign: 'center',
            boxSizing: 'border-box',
            padding: '0 5%',
            ...fontGeneral('64px', 'normal', '1.13', '#000000'),
        },
        '& p': {
            width: '83.33%',
            textAlign: 'center',
            boxSizing: 'border-box',
            padding: '0 6%',
            marginTop: '0',
            ...fontGeneral('18px', 'normal', '1.33', '#000000'),
        },
    },

    secondSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
    },

    homeSecondSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            margin: '40px 0px 0px 0px',
            width: '100%',
        },
    },

    homeSectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
            // flexDirection: 'column',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            flexDirection: 'column',
        },
    },

    secondSectionText: {
        width: '43%',
        textAlign: 'left',
        paddingRight: '70px',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',

        '& h2': {
            margin: '0px 0px 8px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& p': {
            margin: '0px',
            // padding: '0px 24% 0px 0px',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
        '& h4': {
            // margin: '0px 0px 32px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },
        '& span': {
            margin: '16px 0px 0px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },
        '& strong': {
            margin: '16px 0px 0px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%',
            paddingRight: '0px',
            alignSelf: 'center',
            '& h2': {
                fontSize: '28px',
            },
            '& p': {
                padding: '0px 0px 0px 0px',
            },
        },
    },

    secondSectionImage: {
        width: '50%',
        display: 'flex',
        alignSelf: 'flex-start',

        [theme.breakpoints.down('xs')]: {
            marginTop: '16px',
            width: '78%',
        },
    },

    thirdSectionImage: {
        width: '50%',
        display: 'flex',
        alignSelf: 'flex-start',

        [theme.breakpoints.down('xs')]: {
            marginTop: '24px',
            width: '80%',
            alignSelf: 'flex-end',

        },
    },

    homeThirdSectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
            // flexDirection: 'column',
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
            width: '100%',
        },
    },

    homeThirdSectionBox_op2: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
            // flexDirection: 'column',
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            marginBottom: '16px',
        },
    },

    secondSectionImage_op2: {
        width: '50%',
        display: 'flex',
        alignSelf: 'flex-start',

        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },

    thirdSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '40px 0px 0px 0px',
        },
    },

    thirdSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '62%',
        zIndex: '-1',
        marginTop: '92px',

        [theme.breakpoints.down('xs')]: {
            marginTop: '-70%',
            height: '82%',
        },
    },

    thirdSectionText: {
        width: '40%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        padding: '50px 0 0 10%',

        '& h2': {
            ...fontGeneral('34.5px', 'bold', '1.2', '#ffffff'),
        },

        '& p': {
            margin: '0px',
            ...fontGeneral('18px', '300', '1.2', '#ffffff'),
        },
        '& span': {
            // margin: '16px 0px 0px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
        },

        [theme.breakpoints.down('xs')]: {
            width: '81%',
            alignSelf: 'center',
            padding: '0',
            '& h2': {
                margin: '0 0 24px 0',
            },
            '& p': {
                padding: '0px 0px 0px 0px',
                // fontSize: '12px',
            },
        },
    },

    thirdSectionText_op2: {
        width: '48%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-end',
        padding: '0 3% 0 0',
        '& h2': {
            textAlign: 'center',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000'),
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            alignSelf: 'center',
            padding: '0 0 0 0',

            '& h2': {
                textAlign: 'left',
                margin: '0 0 16px 0',
            },
        },
    },

    thirdSectionBoxesBlack: {
        display: 'flex',
        width: '100%',
        // justifyContent: 'space-between',
        justifyContent: 'center',
        flexWrap: 'wrap',

        '& a': {
            backgroundColor: '#000',
            width: '30%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            padding: '9% 0',
            margin: '4px 2px',
        },

        '& div': {
            width: '100%',
            textAlign: 'center',
            alignSelf: 'center',
            '& svg': {
                fill: '#FFFFFF',
                width: '80%',
            },
            '& img': {
                fill: '#FFFFFF',
                width: '80%',
            },
        },

        '& a:hover': {
            backgroundColor: 'rgba(0,0,0,0.6)',
        },



    },

    fourthSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '10px 0 0 0',
        },
    },

    homeFourthSectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
            // flexDirection: 'column',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },

    fourthSectionImage: {
        width: '50%',
        display: 'flex',
        alignSelf: 'flex-start',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#000',

        '& img:hover': {
            opacity: '0.6',
            zIndex: '1',
        },
    },

    fourthSectionImages: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },

    fourthSectionOption: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        margin: '0px',
        transform: 'translate(-50%, -50%)',
        ...fontGeneral('34.5px', 'bold', '1.2', '#ffffff'),
        [theme.breakpoints.down('xs')]: {
            fontSize: '20px',
        },
    },

    fourthSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '685px',
        zIndex: '-1',
        marginTop: '280px',

        [theme.breakpoints.down('xs')]: {
            position: 'relative',
            display: 'none',
        },
    },

    // -------------------------------------------------------------------------------------------------
    //-------------------------------ABOUT US
    // -------------------------------------------------------------------------------------------------
    aboutUsContainerSectionHome: {
        top: '0px',
        width: '100%',
        height: '400px',
        position: 'absolute',
    },

    aboutUsImageHome: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },

    aboutUsSecondSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        marginTop: '430px',
        marginBottom: '28px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '430px 0px 0px 0px',
        },
    },

    aboutUssecondSectionText: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',

        '& h2': {
            margin: '0px 0px 16px 0px',
            textAlign: 'left',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& p': {
            margin: '0px',
            textAlign: 'left',
            // padding: '0px 24% 0px 0px',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
    },

    aboutUsSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '64%',
        zIndex: '-1',
        marginTop: '92px',

        [theme.breakpoints.down('xs')]: {
            marginTop: '-70%',
            height: '82%',
        },
    },

    aboutUsThirdSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '40px 0px 0px 0px',
        },
    },
    aboutUsThirdTextH2: {
        margin: '0',
        ...fontGeneral('34.5px', 'bold', '1.2', '#FFFFFF'),

        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
            display: 'none',
        },
    },

    aboutUsList: {
        display: 'flex',
        listStyleType: 'none',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        padding: '0',

        '& li': {
            width: '24%',
            textAlign: 'center',

            '& h3': {
                margin: '24px 0 8px 0',
                ...fontGeneral('36.5px', 'bold', '1.2', '#0a0a0a'),
            },
            '& span': {
                ...fontGeneral('18px', '300', '1.2', '#0a0a0a'),
            },

            '& h4': {
                margin: '24px 0 8px 0',
                ...fontGeneral('18px', 'bold', '1.2', '#0a0a0a'),
            },
            '& div': {
                backgroundColor: '#000',
                width: '100%',
                height: '100%',
                borderRadius: '50px',
            },
        },

        [theme.breakpoints.down('xs')]: {
            '& li': {
                width: '50%',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
        },
    },

    aboutUsList_Op2: {
        display: 'flex',
        listStyleType: 'none',
        justifyContent: 'left',
        marginTop: '10px',
        flexWrap: 'wrap',
        padding: '0px',

        '& li': {
            width: '25%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',

            '& h4': {
                margin: '8px 0 1px 0',
                textAlign: 'left',
                width: '81%',
                ...fontGeneral('18px', 'bold', '1.2', '#0a0a0a'),
            },
            '& p': {
                margin: '0px 0 24px 0',
                textAlign: 'left',
                width: '81%',
                ...fontGeneral('18px', '300', '1.2', '#0a0a0a'),
            },
            '& div': {
                width: '80px',
                height: '80px',
                borderRadius: '50px',

                '& img': {
                    borderRadius: '50px',
                    border: '0.5px solid #515151'
                },
            },
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0 0px 0 20px',
            '& li': {
                width: '50%',
            }
        },
    },

    aboutUsList_Op3: {
        display: 'flex',
        listStyleType: 'none',
        // justifyContent: 'space-between',
        justifyContent: 'center',
        padding: '0',
        flexDirection: 'row',
        flexWrap: 'wrap',

        '& li': {
            width: '30%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '6px 6px',

            '& p': {
                margin: '18px 0 8px 0',
                ...fontGeneral('18px', '300', '1.2', '#0a0a0a'),
            },

            '& h4': {
                margin: '24px 0 8px 0',
                ...fontGeneral('18px', 'bold', '1.2', '#0a0a0a'),
            },
            '& div': {
                width: '71%',
                height: '90px',
                display: 'flex',
                alignItems: 'center',


                '& svg': {
                    fill: '#000',
                    width: '100%',
                },

                '& img': {
                    fill: '#000',
                    width: '100%',
                }
            },
        },

        '& svg:hover': {
            opacity: '0.6',
            // padding: '0 8px',
            // fill: 'rgba(128,128,128,0.7)',
        },

        '& img:hover': {
            opacity: '0.6',
        },

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            '& li': {
                width: '100%',
                padding: '0 0px',
                '& div': {
                    width: '81%',
                },
            },
        },
    },

    fourSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: '58%',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '0px 0px 0px 0px',
            marginTop: '10%',
        },
    },

    aboutUsFourSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: '36%',
        marginBottom: '28px',
        [theme.breakpoints.down('xs')]: {
            width: '90%',
            margin: '40px 0px 0px 0px',
            marginTop: '25%',
        },
    },

    aboutUsSectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#fff',
        padding: '32px',
        // [theme.breakpoints.down('xs')]: {
        //     width: '100%',
        // },
    },

    aboutUsfourSectionText: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',

        '& h2': {
            margin: '0px 0px 16px 0px',
            textAlign: 'left',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },
    },

    // -------------------------------------------------------------------------------------------------
    //-------------------------------OUR WORK - NEWS
    // -------------------------------------------------------------------------------------------------
    workSecondSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '20px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '20px 0px 0px 0px',
        },
    },

    workSectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },

    workfirstSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',
        padding: '0 5px',
        cursor: 'pointer',

        '& h2': {
            margin: '0px 0px 32px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },
        '& h4': {
            textAlign: 'left',
            margin: '16px 0px 0px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
        },

        '& div': {
            backgroundColor: '#000000',
            width: '100%',
            alignSelf: 'center',
        },
        '& img': {
            width: '100%',
            alignSelf: 'center',
        },

        '& p': {
            margin: '24px 0 0 0 ',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#ffffff'),
        },

        '& img:hover': {
            backgroundColor: 'rgba(0,0,0,1)',
            opacity: '0.6',
        },
        '& h4:hover': {
            color: 'rgba(128,128,128,0.6)',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '60px',
            padding: '0 0px',
            '& h2': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '28px',
            },
            '& h4': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
            },
            '& p': {
                width: '81%',
                margin: '24px 0 0 0 ',
                textAlign: 'left',
                alignSelf: 'center',
                fontSize: '18px',
            },
        },

    },
    workSecondSectionImages: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',

        '& ul': {
            display: 'flex',
            listStyleType: 'none',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: '0px',
            margin: '0',
            flexWrap: 'wrap',

            '& li': {
                width: '50%',
                cursor: 'pointer',
                margin: '32px 0 0 0',

                '& div': {
                    backgroundColor: '#000000',
                    width: '96%',
                    alignSelf: 'center',
                    display: 'flex',
                    height: 'auto',
                },
                '& img': {
                    width: '100%',
                    alignSelf: 'center',
                    height: 'auto',
                    backgroundColor: '#000000',
                },
                '& video': {
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                },

                '& video:hover': {
                    opacity: '0.6',
                },
                '& h4': {
                    margin: '16px 0px 0px 0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                },
                '& p': {
                    margin: '0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                },
                // '& img:hover':{
                //     opacity: '0.9',

                // },

            },
            '& img:hover': {
                backgroundColor: '#000000',
                opacity: '0.6',
            },

            '& h4:hover': {
                color: 'rgba(128,128,128,0.6)',
            },
        },
    },

    workH4: {
        ...fontGeneral('18px', 'bold', '1.2', '#FFFFFF'),
        [theme.breakpoints.down('xs')]: {
            fontSize: '18px',
        },
    },
    workP: {
        ...fontGeneral('18px', '300', '1.2', '#FFFFFF'),
        [theme.breakpoints.down('xs')]: {
            fontSize: '18px',
        },
    },
    workH4_Black: {
        ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        [theme.breakpoints.down('xs')]: {
            fontSize: '18px',
        },
    },
    workP_Black: {
        ...fontGeneral('18px', '300', '1.2', '#000000'),
        [theme.breakpoints.down('xs')]: {
            fontSize: '18px',
        },
    },

    workSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '100%',
        zIndex: '-1',
        marginTop: '440px',
        [theme.breakpoints.down('md')]: {
            height: '85%',
        },
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },

    workSecondSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '6%',
        zIndex: '-1',
        marginTop: '430px',
        [theme.breakpoints.down('md')]: {
            // display: 'none',
            height: '65%',
            marginTop: '-100px',
        },
        [theme.breakpoints.down('xs')]: {
            // display: 'none',
            height: '66%',
            marginTop: '-100px',
        },
    },

    // -------------------------------------------------------------------------------------------------
    //------------------------------- NEWS
    // -------------------------------------------------------------------------------------------------
    newsSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '100%',
        // height: 'calc(20% - 268px)',
        zIndex: '-1',
        marginTop: '440px',
        [theme.breakpoints.down('md')]: {
            height: 'calc(20% - 268px)',
        },
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },

    newsSecondSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        // height: '6%',
        zIndex: '-1',
        marginTop: '430px',
        [theme.breakpoints.down('md')]: {
            // display: 'none',
            // height: '44%',
            height: 'calc(20% - 278px)',
            marginTop: '-100px',
        },
        [theme.breakpoints.down('xs')]: {
            // display: 'none',
            // height: '46%',
            height: 'calc(20% - 278px)',
            marginTop: '-110px',
        },
    },

    newsExampleFirstSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',
        padding: '0 5px',

        '& h2': {
            margin: '0px 0px 24px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },
        '& h4': {
            cursor: 'pointer',
            margin: '0px 0px 0px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },

        '& img': {
            width: '100%',
            alignSelf: 'center',
        },

        '& video': {
            width: '100%',
            height: '100%',
            cursor: 'pointer',
        },

        '& video:hover': {
            opacity: '0.6',
        },

        '& h4:hover': {
            opacity: '0.4',
            color: 'rgba(128,128,128,0.6)',
        },
        [theme.breakpoints.down('md')]: {
            '& h3': {
                fontSize: '28px',
            },
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '60px',
            padding: '0 0px',
            '& h2': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '28px',
            },

            '& h4': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
            },

        },

    },

    // -------------------------------------------------------------------------------------------------
    //------------------------------- NEWS PAGES
    // -------------------------------------------------------------------------------------------------
    newsPagesFirstSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',
        padding: '0 5px',

        '& h2': {
            margin: '0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& img': {
            width: '100%',
            alignSelf: 'center',
        },

        '& span': {
            margin: '0 0 24px 0',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
        '& p': {
            margin: '0px 0 18px 0',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
            '& a': {
                textDecoration: 'none',
                color: '#0000B7',
            },
        },
        '& video': {
            width: '100%',
            height: '100%',
            cursor: 'pointer',
        },

        '& video:hover': {
            opacity: '0.6',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '60px',
            padding: '0 0px',
            '& h2': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '28px',
            },
            '& p': {
                width: '81%',
                margin: '24px auto 0px auto ',
                textAlign: 'left',
                alignSelf: 'center',
                fontSize: '18px',
            },
            '& span': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '18px',
            },
        },

    },
    // -------------------------------------------------------------------------------------------------
    //-------------------------------OUR WORK EXAMPLES
    // -------------------------------------------------------------------------------------------------
    workExamplesSecondSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '20px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '20px 0px 0px 0px',
        },
    },

    workExampleSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '70%',
        zIndex: '-1',
        marginTop: '440px',
        [theme.breakpoints.down('md')]: {
            height: '66%',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '250px',
            height: '76%',
        },
    },

    workExampleSectionBackgroundOp2: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '70%',
        zIndex: '-1',
        marginTop: '440px',
        [theme.breakpoints.down('md')]: {
            height: '60%',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '260px',
            height: '70%',
        },
    },

    workExampleSectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },

    workExampleFirstSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',
        padding: '0 5px',

        '& h2': {
            margin: '0px 0px 24px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },
        '& h3': {
            margin: '0px 0px 24px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#FFFFFF'),
        },
        '& h4': {
            margin: '0px 0px 0px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },
        '& h5': {
            margin: '24px 0px 8px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#FFFFFF'),
        },

        '& img': {
            width: '100%',
            alignSelf: 'center',
        },

        '& p': {
            margin: '0px 0 24px 0 ',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#ffffff'),
        },

        '& span': {
            margin: '0px 0px 24px 0px',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
        '& video': {
            width: '100%',
            height: '100%',
        },

        '& video:hover': {
            opacity: '0.6',
        },
        [theme.breakpoints.down('md')]: {
            '& h3': {
                fontSize: '28px',
            },
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '60px',
            padding: '0 0px',
            '& h2': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '28px',
            },
            '& h3': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '28px',
            },
            '& h4': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
            },
            '& h5': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                marginLeft: 'auto',
                marginRight: 'auto',
            },

            '& p': {
                width: '81%',
                textAlign: 'left',
                alignSelf: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
            },
            '& span': {
                width: '81%',
                textAlign: 'left',
                alignSelf: 'center',
            },
        },

    },

    divVideo: {
        width: '100%',
        height: '100%',
        backgroundColor: '#000000',
        display: 'flex',
        position: 'relative',

        '& svg': {
            fill: '#ffffff',
            width: '40px',
            height: '40px',
            padding: '10px 12px',
            position: 'absolute',
            bottom: '0',
            right: '0',
            cursor: 'pointer',
        },

        '& #playButton': {
            // top: '0',
            // right: '0',
            // left: '0',
            // bottom: '0',
            // width: '80px',
            // height: '80px',
            width: '50px',
            height: '50px',
            opacity: '0.2',
            // padding: '0px',
            // margin: 'auto',
        },

        '& #playButton:hover': {
            opacity: '1',
            zIndex: '99',
            fill: '#ffffff',
        },
    },

    workExampleContentSecondBlock: {
        display: 'flex',
        '& div': {
            width: '50%',

            '& img': {
                width: '100%',
                alignSelf: 'center',
            },
        },

        '& h3': {
            width: '40%',
            alignSelf: 'center',
            padding: '0 0 0 80px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%',
            alignSelf: 'center',
            textAlign: 'left',
            '& h3': {
                fontSize: '18px',
                padding: '0 0 0 40px',
            },
        },
    },

    workExampleContentThirdBlock: {

    },

    workExampleSecondSectionImages: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',

        '& h4': {
            margin: '0px 0px 8px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },

        '& p': {
            margin: '0px 0 24px 0 ',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
        '& img': {
            width: '100%',
            alignSelf: 'center',
            marginTop: '24px',
        },

        '& ul': {
            display: 'flex',
            listStyleType: 'none',
            justifyContent: 'center',
            listStyle: 'none',
            padding: '0px',
            margin: '0 0 0 0',
            flexWrap: 'wrap',

            '& li': {
                width: '25%',
                cursor: 'pointer',
                '& h3': {
                    margin: '16px 0px 0px 0px',
                    textAlign: 'center',
                    ...fontGeneral('36.5px', 'bold', '1.2', '#0a0a0a'),
                },
                '& p': {
                    margin: '0px',
                    textAlign: 'center',
                    ...fontGeneral('18px', '300', '1.2', '#0a0a0a'),
                },
            },
        },
        [theme.breakpoints.down('md')]: {
            '& ul': {
                '& li': {
                    padding: '5px 16px',
                },
            },
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            '& ul': {
                justifyContent: 'space-between',

                '& li': {
                    width: '40% !important',
                    padding: '5px 5px',

                    '& p': {
                        fontSize: '18px',
                    },
                },
            },
        },
    },

    // -------------------------------------------------------------------------------------------------
    //-------------------------------CAREERS
    // -------------------------------------------------------------------------------------------------
    careersSecondSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '40px 0px 0px 0px',
        },
    },

    careersSectionBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },

    carrersfirstSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',

        '& h2': {
            margin: '0px 0px 32px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& p': {
            margin: '0px 0 18px 0 ',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
    },

    carrersSecondSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',

        '& h3': {
            textAlign: 'left',
            ...fontGeneral('18px', 'bold', '1.2', '#FFFFFF'),
        },

        '& ul': {
            display: 'flex',
            listStyleType: 'none',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: '0px',
            margin: '32px 0 0 0',
            flexWrap: 'wrap',

            '& li': {
                width: '27%',
                cursor: 'pointer',
                display: 'flex',
                padding: '0 8px',

                '& a': {
                    textDecoration: 'none',
                    marginBottom: '24px',
                    '& h4': {
                        textAlign: 'left',
                        margin: '0 0 5px 0',
                        ...fontGeneral('18px', 'bold', '1.2', '#FFFFFF'),
                    },
                    '& span': {
                        textAlign: 'left',
                        marginBottom: '16px',
                        ...fontGeneral('18px', '300', '1.2', '#FFFFFF'),
                    },

                },
                '& h4:hover': {
                    color: 'rgba(128,128,128,0.6)',
                },
            },
        },
        [theme.breakpoints.down('md')]: {

        },
        [theme.breakpoints.down('xs')]: {

            '& h3': {
                width: '81%',
                margin: '0 0 0 0',
                alignSelf: 'center',
                justifyContent: 'center',
            },

            '& ul': {
                width: '100%',
                alignSelf: 'center',
                justifyContent: 'center',
                '& li': {
                    width: '39% !important',
                },
            },
        },
    },

    careersIframe: {
        height: '370px',
        [theme.breakpoints.down('xs')]: {
            height: '450px',
            width: '100%',
            padding: '0 5px'
        },
    },

    carrersThirdSectionImages: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',

        '& h3': {
            textAlign: 'left',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& ul': {
            display: 'flex',
            listStyleType: 'none',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: '0px',
            margin: '32px 0 0 0',

            '& li': {
                width: '81%',
                cursor: 'pointer',
                '& img': {
                    width: '95% !important',
                    alignSelf: 'center',
                    borderRadius: '50%',
                },
                '& h4': {
                    margin: '16px 0px 0px 0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                },
                '& p': {
                    margin: '0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                }
            },

            '& img:hover': {
                opacity: '0.6',
            },

            '& h4:hover': {
                color: 'rgba(128,128,128,0.7)',
            },
        },
        [theme.breakpoints.down('md')]: {

        },
        [theme.breakpoints.down('xs')]: {
            '& h3': {
                width: '81%',
                margin: '0 0 0 0',
                fontSize: '28px',
                alignSelf: 'center',
                justifyContent: 'center',
            },
            '& ul': {
                width: '81%',
                alignSelf: 'center',
                justifyContent: 'center',

                '& li': {
                    width: '33% !important',
                },

            },
        },
    },

    carrersThirdSectionImagesV2: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',

        '& h3': {
            textAlign: 'left',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& ul': {
            display: 'flex',
            listStyleType: 'none',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: '0px',
            margin: '32px 0 0 0',
            flexWrap: 'wrap',

            '& li': {
                width: '30%',
                cursor: 'pointer',
                '& img': {
                    width: '95% !important',
                    alignSelf: 'center',
                    borderRadius: '50%',
                },
                '& h4': {
                    margin: '16px 0px 0px 0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                },
                '& p': {
                    margin: '0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                }
            },

            '& img:hover': {
                opacity: '0.6',
            },

            '& h4:hover': {
                color: 'rgba(128,128,128,0.7)',
            },
        },
        [theme.breakpoints.down('md')]: {

        },
        [theme.breakpoints.down('xs')]: {
            '& h3': {
                width: '81%',
                margin: '0 0 0 0',
                fontSize: '28px',
                alignSelf: 'center',
                justifyContent: 'center',
            },
            '& ul': {
                width: '81%',
                alignSelf: 'center',
                justifyContent: 'center',

                '& li': {
                    width: '33% !important',
                },

            },
        },
    },

    careersSectionBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '100%',
        zIndex: '-1',
        marginTop: '20px',
    },

    careersCollapseBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        width: '1000%',
        left: '-3000px',
        height: '100%',
        zIndex: '-1',
        // top: '0',
        // marginTop: '42%',
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },

    careersContainerCollapse: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#000000',
        textAlign: 'left',
        marginTop: '28px',
        position: 'relative',
    },

    careersCollapse: {
        display: 'flex',
        alignSelf: 'center',
        justifyContent: 'center',
        // marginTop:'20px',
        // marginBottom:'15px',
        '& h2': {
            margin: '0px 0 5px 0',
            ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
        },
        '& p': {
            margin: '0px 0 18px 0',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#ffffff'),
        },
        '& button:hover': {
            color: 'rgba(128,128,128,0.6)',
        },
        [theme.breakpoints.down('xs')]: {
            '& h2': {
                width: '81%',
                margin: '0px auto 5px auto',
            },
            '& p': {
                width: '81%',
                margin: '0px auto 18px auto',
            },
        },
    },

    careersIndicator1: {
        borderRight: '24px solid transparent',
        borderLeft: '24px solid transparent',
        borderBottom: '24px solid #000000',
        position: 'absolute',
        marginTop: '-23px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '50px',
        },
    },
    careersIndicator2: {
        borderRight: '24px solid transparent',
        borderLeft: '24px solid transparent',
        borderBottom: '24px solid #000000',
        position: 'absolute',
        marginTop: '-23px',
        marginLeft: '28%',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '38%',
        },
    },
    careersIndicator3: {
        borderRight: '24px solid transparent',
        borderLeft: '24px solid transparent',
        borderBottom: '24px solid #000000',
        position: 'absolute',
        marginTop: '-23px',
        marginLeft: '55%',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '65%',
        },
    },

    careersButtonClose: {
        margin: '10px 0px 0px 0px',
        padding: '0px 0px 10px 0',
        ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },


    // -------------------------------------------------------------------------------------------------
    //-------------------------------TERMS
    // -------------------------------------------------------------------------------------------------
    termsfirstSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',

        '& h2': {
            margin: '0px 0px 32px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& p': {
            margin: '0px 0 18px 0 ',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },

        '& ul': {
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },

        '& ol': {
            listStyleType: 'none',
            margin: '0',
            padding: '0',
            counterReset: 'item',

            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },

        '& li': {
            display: 'table',
            counterIncrement: 'item',
            marginBottom: '0.6em',

            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },

        '& li:before': {
            content: 'counters(item, ".") ". "',
            display: 'table-cell',
            paddingRight: '0.6em',
        },

        '& li li': {
            margin: '16px 0px',
        },

        '& li li:before': {
            content: 'counters(item, ".") " "',
        },

        // '& li:before': { 
        //     content: 'counters(item, ".") " "; counter-increment: item' 
        // },

        // '& .ql-indent-1:before':{
        //     content: 'counters(item, ".") " "; counter-increment: item'
        // },        

    },

    // -------------------------------------------------------------------------------------------------
    //-------------------------------CONTACT
    // -------------------------------------------------------------------------------------------------
    contactSecondSectionContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '40px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '40px 0px 0px 0px',
        },
    },

    contactFirstSectionText: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',

        '& h2': {
            margin: '0px 0px 32px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& h3': {
            margin: '0px 0px 16px 0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },

        '& p': {
            textAlign: 'left',
            alignSelf: 'center',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
        '& button:hover': {
            opacity: '0.7',
            // color: 'rgba(128,128,128,0.6)',
        },

        [theme.breakpoints.down('xs')]: {
            '& h2': {
                textAlign: 'left',
            },
        },
    },

    // -------------------------------------------------------------------------------------------------


    containerSectionHome: {
        top: '0px',
        width: '100%',
        height: 'auto',
        position: 'absolute',
    },


    sectionAboutUs: {
        // position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
    },

    containerSectionHomeMobile: {
        // top: '0px',
        width: '100%',
        height: '100%',
        // position: 'relative',
        // // position: 'absolute',
        // '& svg': {
        //     height: '100%',
        // },
    },


    paddingBlock: {
        display: 'flex',
        textAlign: 'center',
        fontSize: '5vmax',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#efefef',
        color: '#333',
    },

    scrollCarousel: {
        backgroundColor: '#fff',
    },

    stickyBox: {
        position: 'sticky',
        top: '0',
        overflow: 'hidden',
    },

    transformBox: {
        display: 'flex',
        willChange: 'transform',
    },

    box: {
        width: '76rem',
        height: '100%',
        flexShrink: '0',
        margin: '0 2rem',
        // width: '100%',
        // height: '100%',
        // margin: '0 100px 0 100px',
    },

    img: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },

    imageHome: {
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
    },

    imageHome_op2: {
        width: '100%',
        height: '100%',
    },

    containerSection2Home: {
        top: '537px',
        width: '100%',
        position: 'relative',
        display: 'flex',
        margin: '40px 0px',
        padding: '0px 16px',
    },

    boxSection2Image: {
        width: '50%',
    },

    divSection2Text: {
        width: '50%',
        textAlign: 'left',
        paddingRight: '72px',

        '& h2': {
            margin: '0px 0px 32px 0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },

        '& p': {
            margin: '0px',
            padding: '0px 98px 0px 0px',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
    },

    backgroundBlack: {
        backgroundColor: '#000000',
        // position: 'absolute',
        width: '100%',
    },

    newsSecondSectionImages: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',

        '& ul': {
            display: 'flex',
            listStyleType: 'none',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: '0px',
            margin: '0',
            flexWrap: 'wrap',

            '& li': {
                width: '50%',
                cursor: 'pointer',
                margin: '32px 0 0 0',

                '& div': {
                    backgroundColor: '#000000',
                    width: '96%',
                    alignSelf: 'center',
                    display: 'flex',
                    height: 'auto',
                },
                '& img': {
                    width: '100%',
                    alignSelf: 'center',
                    height: 'auto',
                    backgroundColor: '#000000',
                },
                '& video': {
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                },

                '& video:hover': {
                    opacity: '0.6',
                },
                '& h4': {
                    margin: '16px 0px 0px 0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                },
                '& p': {
                    margin: '0px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                },
            },
            '& img:hover': {
                backgroundColor: '#000000',
                opacity: '0.6',
            },

            '& h4:hover': {
                color: 'rgba(128,128,128,0.6)',
            },
        },
    },

    divProgress: {
        height: '600px',
        display: 'flex',
        alignItems: 'center',
    },

    progress: {
        display: 'flex',
        zIndex: '1',
        margin: '60px auto 0 auto ',
        '&.MuiCircularProgress-colorPrimary': {
            color: '#000',
        }
    },


    // -------------------------------------------------------------------------------------------------
    //-------------------------------TERMS & CONDITIONS
    // -------------------------------------------------------------------------------------------------

    termsAndConditionsPage: {
        width: '81%',
        maxWidth: '1136px',
        margin: '20px 16px 0px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '20px 0px 0px 0px',
        },
    },

    termsAndConditionsBox: {
        width: '81%',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            width: '81%',
        },
    },

    termsAndConditionsCategories: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        alignSelf: 'center',
        // justifyContent: 'space-between',
        justifyContent: 'start',
        flexWrap: 'wrap',
        marginTop: '8px',

        [theme.breakpoints.down('xs')]: {
            width: '81%',
        },
    },

    termsAndConditionsCategoriesBox: {
        width: '28%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        background: '#ededed',
        marginTop: '20px',
        height: '200px',
        position: 'relative',
        padding: '8px',
        marginRight: '15px',

        '& h2': {
            textAlign: 'left',
            padding: '20px 12px',
            ...fontGeneral('15px', 'bold', '1.2', '#000000'),
        },

        '& a': {
            textAlign: 'left',
            padding: '20px 12px',
            textDecoration: 'underline',
            fontWeight: '200',
            cursor: 'pointer',
            position: 'absolute',
            bottom: '0',
            ...fontGeneral('14px', '200', '1.2', '#000000'),
        },
        [theme.breakpoints.down('md')]: {
            width: '28%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '43%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginTop: '10px',
        },
    },

    termsAndConditionsSectionTitle: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '108px',
        justifyContent: 'center',
        padding: '0 5px',

        '& h2': {
            margin: '0px',
            ...fontGeneral('34.5px', 'bold', '1.2', '#000000'),
        },
        '& span': {
            margin: '0 0 24px 0',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
        },
        '& a': {
            margin: '0 0 10px 0',
            textAlign: 'left',
            textDecoration: 'underline',
            cursor: 'pointer',
            ...fontGeneral('14px', '300', '1.2', '#000000'),
        },
        '& p': {
            margin: '0px 0 18px 0',
            textAlign: 'left',
            alignSelf: 'flex-start',
            ...fontGeneral('18px', '300', '1.2', '#000000'),
            '& a': {
                textDecoration: 'none',
                color: '#0000B7',
            },
        },

        [theme.breakpoints.down('xs')]: {
            marginTop: '60px',
            padding: '0 0px',
            '& span': {
                width: '100%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '18px',
            },
            '& h2': {
                width: '81%',
                alignSelf: 'center',
                textAlign: 'left',
                fontSize: '28px',
            },
            '& p': {
                width: '81%',
                margin: '24px auto 0px auto ',
                textAlign: 'left',
                alignSelf: 'center',
                fontSize: '18px',
            },
            '& a': {
                width: '81%',
                margin: '24px auto 0px auto ',
            },
        },
    },

    termsAndConditionsLink: {
        display: 'flex',
        justifyContent: 'flex-start',

        '& a': {
            margin: '10px 10px 10px 0',
            textAlign: 'left',
            textDecoration: 'underline',
            cursor: 'pointer',
            ...fontGeneral('14px', '300', '1.2', '#000000'),
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%',
            margin: '24px auto 0px auto ',
            '& a': {
                // width: '81%',
                // margin: '24px auto 0px auto ',
            },
        },
    },

    termsAndConditionsCategories_ul_null: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        alignSelf: 'left',
        listStyleType: 'none',
        padding: '0 0 0 0px',
        '& li': {
            textDecoration: 'underline',
            cursor: 'pointer',
            ...fontGeneral('16px', '300', '1.2', '#000000'),
        },
    },

    termsAndConditionsCategories_ul: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        alignSelf: 'left',
        listStyleType: 'none',
        padding: '0 0 0 0px',
        '& li': {
            margin: '10px 0 0 0',
            ...fontGeneral('18px', '500', '1.2', '#000000'),
            '& ul': {
                padding: '0 32px',
                listStyleType: 'disclosure-closed',
               
                '& li': {
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    ...fontGeneral('16px', '300', '1.2', '#000000'),
                },
            },
        },
        [theme.breakpoints.down('xs')]: {

        },
    },


    academyContent: {
        width: '81%',
        maxWidth: '1136px',
        margin: '70px 16px 25px 16px',
        display: 'flex',
        color: '#000000',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '60px 0px 20px 0px',
        },
    },
    
    academyBlackBackground: {
        overflow: 'hidden',
        background: '#000',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '100%',
        zIndex: '-1',
        [theme.breakpoints.down('xs')]: {
            height: '100%',
        },
    },

    academyBlackParagraph: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        padding: '0px 0 0 0',
        marginBottom: '30px',

        '& p': {
            margin: '0px',
            ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%',
            alignSelf: 'center',
            padding: '0',
            '& p': {
                padding: '0px 0px 0px 0px',
            },
        },
    },

    academyBlackSectionText: {
        width: '50%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        padding: '30px 0 0 0',
        marginBottom: '50px',

        '& h2': {
            margin: '0 0 30px 0',
            ...fontGeneral('32.5px', 'bold', '1.2', '#ffffff'),
        },

        '& p': {
            margin: '0px',
            ...fontGeneral('16px', '300', '1.2', '#ffffff'),
        },

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            alignSelf: 'center',
            padding: '0',
            '& h2': {
                fontSize: '28px',
            },
        },
    },

    academySectionImage: {
        width: '40%',
        display: 'flex',
        alignSelf: 'flex-start',
        flexDirection: 'column',
        padding: '30px 0 0 8%',

        '& img': {
            margin: '0px 0px 20px 0px',
        },
        '& p': {
            margin: '0px',
            ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
            fontStyle: 'italic',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            alignSelf: 'center',
            padding: '0px',
            marginBottom: '30px',
        },
    },

    academyListContent: {
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        padding: '30px 0 0 0',

        '& h3': {
            margin: '0px',
            ...fontGeneral('18px', 'bold', '1.2', '#ffffff'),
        },
        '& p': {
            margin: '0px',
            ...fontGeneral('16px', '300', '1.2', '#f9f8f8'),
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            alignSelf: 'center',
        },
    },

    academyWhiteParagraph: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        padding: '0px 0 0 0',
        marginBottom: '25px',
        marginTop: '20px',

        '& h2': {
            margin: '0 0 0 0',
            ...fontGeneral('32.5px', 'bold', '1.2', '#000000'),
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%',
            alignSelf: 'center',
            padding: '0',
            '& h2': {
                fontSize: '28px'
            },
        },
    },

    academyWhiteSectionBox: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'row',
        alignSelf: 'flex-start',
        padding: '15px 0 0 0',
        marginBottom: '30px',
        justifyContent: 'space-between',

        [theme.breakpoints.down('xs')]: {
            width: '71%',
            alignSelf: 'center',
            padding: '0',
            flexDirection: 'column',
        },
    },

    academyContentBox: {
        width: '31.5%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        padding: '0px 0 0 0',
        marginBottom: '30px',

        '& p': {
            padding: '10px',
            textAlign: 'center',
            margin: '0 0 0 0',
            ...fontGeneral('16px', '300', '1.2', '#000000'),
            
            '& a': {
                textDecoration: 'none',
                overflowWrap: 'break-word',
                ...fontGeneral('16px', '300', '1.2', '#000000'),
            },
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginBottom: '40px',
        },
    },

    academyBorderBox:{
        border: '0.5px solid #000000', 
        padding: '20px 0px',
        textAlign: 'center',
        marginBottom: '30px',
        '& p': {
            padding: '0px',
            margin: '0px',
            ...fontGeneral('18px', 'bold', '1.2', '#000000'),
        },
        [theme.breakpoints.down('xs')]: {
            marginBottom: '15px',
        },
    },

    academyHeaderGif: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        marginTop: '60px',
        justifyContent: 'center',
        padding: '0',

        '& div': {
            width: '100%',
            alignSelf: 'center',
        },
        '& img': {
            width: '100%',
            alignSelf: 'center',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '40px',
            padding: '0 0px',
        },

    },

}));

export default FormStyles;